import { TEditorFramework, TCSSMode } from 'components/DevSandbox/types';

// Detect framework from JS code keywords (mirrors getGeneratedPageURL auto-detection)
export const detectFrameworkFromCode = (js: string): TEditorFramework => {
  const clean = js
    .replace(/\/\/.*$/gm, '')
    .replace(/\/\*[\s\S]*?\*\//g, '')
    .replace(/(["'`])(?:(?=(\\?))\2.)*?\1/g, '');
  if (
    clean.includes('React') ||
    clean.includes('useState') ||
    clean.includes('useEffect') ||
    clean.includes('createRoot') ||
    clean.includes('</')
  )
    return 'react';
  if (clean.includes('Vue.') || clean.includes('createApp') || clean.includes('.mount(')) return 'vue';
  if (
    clean.includes(': string') ||
    clean.includes(': number') ||
    clean.includes(': boolean') ||
    clean.includes('interface ') ||
    clean.includes('<T>') ||
    clean.includes(': void')
  )
    return 'typescript';
  return 'vanilla';
};

// Resolve JS code from URL params — checks jsx, vue, ts, then js
export const resolveJsParam = (params: URLSearchParams): { code: string; framework: TEditorFramework } => {
  const jsx = params.get('jsx');
  if (jsx) return { code: decodeParam(jsx), framework: 'react' };
  const vue = params.get('vue');
  if (vue) return { code: decodeParam(vue), framework: 'vue' };
  const ts = params.get('ts');
  if (ts) return { code: decodeParam(ts), framework: 'typescript' };
  return { code: decodeParam(params.get('js')), framework: 'vanilla' };
};

// Resolve CSS code from URL params — checks scss, postcss, cssmodules, then css
export const resolveCssParam = (params: URLSearchParams): { code: string; cssMode: TCSSMode } => {
  const scss = params.get('scss');
  if (scss) return { code: decodeParam(scss), cssMode: 'scss' };
  const postcss = params.get('postcss');
  if (postcss) return { code: decodeParam(postcss), cssMode: 'postcss' };
  const cssmodules = params.get('cssmodules');
  if (cssmodules) return { code: decodeParam(cssmodules), cssMode: 'modules' };
  return { code: decodeParam(params.get('css')), cssMode: 'css' };
};

// Get the correct JS param name for the current framework
export const getJsParamName = (framework: TEditorFramework): string => {
  if (framework === 'react') return 'jsx';
  if (framework === 'vue') return 'vue';
  if (framework === 'typescript') return 'ts';
  return 'js';
};

// Get the correct CSS param name for the current CSS mode
export const getCssParamName = (cssMode: TCSSMode): string => {
  if (cssMode === 'scss') return 'scss';
  if (cssMode === 'postcss') return 'postcss';
  if (cssMode === 'modules') return 'cssmodules';
  return 'css';
};

export const decodeParam = (value: string | null): string => {
  if (!value) return '';
  try {
    return decodeURIComponent(atob(value));
  } catch {
    return '';
  }
};

export const encodeParam = (value: string): string => {
  if (!value) return '';
  try {
    return btoa(encodeURIComponent(value));
  } catch {
    return '';
  }
};
